import { userConstants } from './../constants/user.constants';

const initialState = {};

//ckyc
export function ACTIVITY(state = initialState, action) {
  switch (action.type) {
    case userConstants.ACTIVITY_REQUEST:
      return {
        ...state,
        loggingIn: true,
        user: action.user,
        isLoading : true

      };
    case userConstants.ACTIVITY_SUCCESS:
        
      return {
      ...state,
        loggedIn: true,
        activityData: action,
        isLoading : false
      };
    case userConstants.ACTIVITY_FAILURE:
      return {
        ...state,
        isLoading : false
      };
    default:
      return state
  }
}

 